import { render, staticRenderFns } from "./Section.vue?vue&type=template&id=020b285c&scoped=true"
import script from "./Section.vue?vue&type=script&lang=js"
export * from "./Section.vue?vue&type=script&lang=js"
import style0 from "./Section.vue?vue&type=style&index=0&id=020b285c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020b285c",
  null
  
)

export default component.exports